import React from "react";

import { prettyPrintJson } from 'pretty-print-json';
import showdown from "showdown";

import {Modal, ModalClose, ModalDialog, Stack,} from "@mui/joy";
import Button from "@mui/joy/Button";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";

// icoms
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from '@mui/icons-material/Close';


class VariableRepresentation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen:  false,
        }
    }

    setModalOpenTrue(){
        this.setState(
            {
                modalOpen: true,
            }
        );
    }

    setModalOpenFalse() {
        this.setState(
            {
                modalOpen: false,
            }
        );
    }

    retrieveColor(){
        switch (this.props.type) {
            case 'str':
                return 'warning'
            case 'int' :
                return 'success'
            case 'float':
                return 'success'
            case 'bool':
                return 'danger'
            case 'dict':
                return 'indigo'
            case 'list':
                return 'lime'
            case 'md':
                return 'purple'
            default:
                return 'primary'
        }
    }

    renderVariable(){
        switch (this.props.type) {
            case 'str':
            case 'int' :
            case 'float':
            case 'textarea':
                return (
                    <Typography>{this.props.value}</Typography>
                )
            case 'bool':
                return (
                    <>
                        {
                            this.props.value ?
                                <CheckCircleIcon
                                    color={'success'}
                                    sx={{display: 'flex'}}
                                />:
                                <CloseIcon
                                    color={'danger'}
                                    sx={{display: 'flex'}}
                                />
                        }
                    </>
                )
            case 'dict':
            case 'list':
                return (
                    <pre
                        style={{
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word'
                        }}
                        className={'json-container'}
                        dangerouslySetInnerHTML={{
                            __html: prettyPrintJson.toHtml(
                                this.props.value,
                                {
                                    indent: 4,
                                    quoteKeys: "",
                                }
                            )
                        }}
                    />
                )
            case 'md':
                let parser = new showdown.Converter(
                    {
                        tables: true,
                        noHeaderId: true,
                        simplifiedAutoLink: true,
                        openLinksInNewWindow: true,
                    }
                )
                return (
                    <div
                        dangerouslySetInnerHTML={{__html: parser.makeHtml(this.props.value) }}
                    />
                )
            default:
                return <Typography>{this.props.value}</Typography>
        }
    }

    render() {
        return(
            <Stack>
                <Button
                    size={'sm'}
                    color={this.retrieveColor.bind(this)()}
                    onClick={this.setModalOpenTrue.bind(this)}
                >
                    {this.props.name} ({`${this.props.value}`.length})
                </Button>
                <Modal
                    open={this.state.modalOpen}
                >
                    <ModalDialog
                        layout={'center'}
                        size="sm"
                        sx={{
                            overflowY: 'scroll'
                        }}
                    >
                        <ModalClose
                            onClick={this.setModalOpenFalse.bind(this)}
                        />
                        <Stack
                            direction={'row'}
                            spacing={1}
                        >
                            <Typography>Тип:</Typography>
                            <Chip>
                                {this.props.type}
                            </Chip>
                        </Stack>
                        {this.renderVariable.bind(this)()}
                    </ModalDialog>
                </Modal>
        </Stack>
        )
    }
}

export default VariableRepresentation;
